// Photos for each page's slideshow. Files live in public/images/. Write alt text that describes the photo.

export const OUTREACH_PHOTOS = [
  {
    url: '/images/outreach/events/image1.jpg',
    alt: 'Outreach Event 1'
  },
  {
    url: '/images/outreach/events/image2.jpg',
    alt: 'Outreach Event 2'
  },
  {
    url: '/images/outreach/events/image3.jpg',
    alt: 'Outreach Event 3'
  },
  {
    url: '/images/outreach/events/image4.jpg',
    alt: 'Outreach Event 4'
  },
  {
    url: '/images/outreach/events/image5.jpg',
    alt: 'Outreach Event 5'
  },
  {
    url: '/images/outreach/events/image6.jpg',
    alt: 'Outreach Event 6'
  },
  {
    url: '/images/outreach/events/image7.jpg',
    alt: 'Outreach Event 7'
  },
  {
    url: '/images/outreach/events/image8.jpg',
    alt: 'Outreach Event 8'
  },
  {
    url: '/images/outreach/events/image9.jpg',
    alt: 'Outreach Event 9'
  },
  {
    url: '/images/outreach/events/image10.jpg',
    alt: 'Outreach Event 10'
  },
  {
    url: '/images/outreach/events/image11.jpeg',
    alt: 'Outreach Event 11'
  },
  {
    url: '/images/outreach/events/image12.jpg',
    alt: 'Outreach Event 12'
  },
  {
    url: '/images/outreach/events/image13.jpg',
    alt: 'Outreach Event 13'
  },
  {
    url: '/images/outreach/events/image14.jpeg',
    alt: 'Outreach Event 14'
  },
  {
    url: '/images/outreach/events/image15.jpg',
    alt: 'Outreach Event 15'
  },
  {
    url: '/images/outreach/events/image16.jpg',
    alt: 'Outreach Event 16'
  },
  {
    url: '/images/outreach/events/image17.jpg',
    alt: 'Outreach Event 17'
  }
];

export const ROVER_PHOTOS = [
  { url: '/images/rover/rover-1.png', alt: 'Rover Development Image 1' },
  { url: '/images/rover/rover-2.png', alt: 'Rover Development Image 2' },
  { url: '/images/rover/rover-3.png', alt: 'Rover Development Image 3' },
  { url: '/images/rover/rover-4.png', alt: 'Rover Development Image 4' },
];

export const ALEASAT_TEST_PHOTOS = [
  {
    src: '/images/aleasat/test-chamber-portrait.jpg',
    alt: 'The engineering model on its supports inside an open thermal vacuum chamber',
    caption: 'The engineering model in the thermal vacuum chamber'
  },
  {
    src: '/images/aleasat/team-at-chamber.jpg',
    alt: 'Two team members in cleanroom gowns working at the open thermal vacuum chamber',
    caption: 'Preparing the thermal vacuum chamber',
    wide: true
  },
  {
    src: '/images/aleasat/camera-lens-closeup.jpg',
    alt: 'Close-up of the ALEASAT camera lens beneath the circuit board',
    caption: 'The camera lens and circuit board',
    wide: true
  },
  {
    src: '/images/aleasat/test-chamber-window.jpg',
    alt: 'A team member in a hairnet reaching toward the round window of the test chamber, with a model cube in the foreground',
    caption: 'At the test chamber window'
  },
  {
    src: '/images/aleasat/board-in-hand.jpg',
    alt: 'A gloved hand holding an ALEASAT circuit board marked with mission partner logos',
    caption: 'A mission circuit board'
  },
  {
    src: '/images/aleasat/esa-cleanroom-assembly.jpg',
    alt: 'Gloved hands beside the camera assembly, with a cleanroom gown marked ESA Fly Your Satellite',
    caption: 'Assembly in the cleanroom',
    wide: true
  },
  {
    src: '/images/aleasat/payload-on-vibration-table.jpg',
    alt: 'ALEASAT camera and electronics bolted to a vibration test table',
    caption: 'The camera and electronics on the shaker table',
    wide: true
  },
  {
    src: '/images/aleasat/threadlocker-application.jpg',
    alt: 'Applying threadlocker to a fastener on the ALEASAT electronics stack',
    caption: 'Applying threadlocker during assembly'
  }
];

export const ALEASAT_PHOTOS = [
  { url: '/images/aleasat/hardware-on-test-table.jpg', alt: 'ALEASAT electronics stack and camera on a perforated test table' },
  { url: '/images/aleasat/test-chamber-integration.jpg', alt: 'Gloved hands connecting wiring to the ALEASAT cube inside the test chamber' },
  { url: '/images/aleasat/lens-adjustment-closeup.jpg', alt: 'A gloved hand holding a lens component over a test table' },
  { url: '/images/aleasat/chamber-through-window.jpg', alt: 'Hardware inside the test chamber, seen through its window' },
  { url: '/images/aleasat/test-chamber-door.jpg', alt: 'The closed door of the test chamber with a round viewing window' },
  { url: '/images/aleasat/board-stack.jpg', alt: 'The ALEASAT electronics stack on an assembly fixture' },
  { url: '/images/aleasat/board-on-shaker-top.jpg', alt: 'Circuit board seen from above on the vibration table' },
  { url: '/images/aleasat/payload-assembly.jpg', alt: 'Gloved hands assembling the camera payload on a fixture' },
  { url: '/images/aleasat/structure-handling.jpg', alt: 'Gloved hands holding a slotted metal structure on a cleanroom bench' },
  { url: '/images/aleasat/payload-on-vibration-table-portrait.jpg', alt: 'The camera payload mounted on the vibration table' },
  { url: '/images/projects/image1', alt: 'Project Image 1' },
  { url: '/images/projects/image2', alt: 'Project Image 2' },
  { url: '/images/projects/image3', alt: 'Project Image 3' },
  { url: '/images/projects/image4', alt: 'Project Image 4' },
  { url: '/images/projects/image5', alt: 'Project Image 5' },
  { url: '/images/projects/image6', alt: 'Project Image 6' },
  { url: '/images/projects/image7', alt: 'Project Image 7' },
  { url: '/images/projects/image8', alt: 'Project Image 8' },
  { url: '/images/projects/image9', alt: 'Project Image 9' },
  { url: '/images/projects/image10', alt: 'Project Image 10' },
  { url: '/images/projects/image11', alt: 'Project Image 11' },
  { url: '/images/projects/image12', alt: 'Project Image 12' },
  { url: '/images/projects/image13', alt: 'Project Image 13' },
  { url: '/images/projects/image14', alt: 'Project Image 14' },
  { url: '/images/projects/image15', alt: 'Project Image 15' },
  { url: '/images/projects/image16', alt: 'Project Image 16' },
  { url: '/images/projects/image17', alt: 'Project Image 17' },
  { url: '/images/projects/image18', alt: 'Project Image 18' },
  { url: '/images/projects/image19', alt: 'Project Image 19' },
  { url: '/images/projects/image20', alt: 'Project Image 20' },
  { url: '/images/projects/image21', alt: 'Project Image 21' },
  { url: '/images/projects/image22', alt: 'Project Image 22' },
  { url: '/images/projects/image23', alt: 'Project Image 23' },
  { url: '/images/projects/image24', alt: 'Project Image 24' },
  { url: '/images/projects/image25', alt: 'Project Image 25' },
  { url: '/images/projects/image26', alt: 'Project Image 26' },
  { url: '/images/projects/image27', alt: 'Project Image 27' },
];

export const BALLOON3_PHOTOS = [
  { url: '/images/balloon3/image1', alt: 'Balloon 3 Gallery 1' },
  { url: '/images/balloon3/image2', alt: 'Balloon 3 Gallery 2' },
  { url: '/images/balloon3/image3', alt: 'Balloon 3 Gallery 3' },
  { url: '/images/balloon3/image4', alt: 'Balloon 3 Gallery 4' },
  { url: '/images/balloon3/image5', alt: 'Balloon 3 Gallery 5' },
  { url: '/images/balloon3/image6', alt: 'Balloon 3 Gallery 6' },
  { url: '/images/balloon3/image7', alt: 'Balloon 3 Gallery 7' },
  { url: '/images/balloon3/image8.jpg', alt: 'Balloon 3 Gallery 8' },
  { url: '/images/balloon3/image9', alt: 'Balloon 3 Gallery 9' },
  { url: '/images/balloon3/image10', alt: 'Balloon 3 Gallery 10' },
  { url: '/images/balloon3/image11', alt: 'Balloon 3 Gallery 11' },
  { url: '/images/balloon3/image12', alt: 'Balloon 3 Gallery 12' },
  { url: '/images/balloon3/image13', alt: 'Balloon 3 Gallery 13' },
  { url: '/images/balloon3/image14', alt: 'Balloon 3 Gallery 14' },
  { url: '/images/balloon3/image15', alt: 'Balloon 3 Gallery 15' },
  { url: '/images/balloon3/image16', alt: 'Balloon 3 Gallery 16' },
  { url: '/images/balloon3/image17', alt: 'Balloon 3 Gallery 17' },
  { url: '/images/balloon3/image18', alt: 'Balloon 3 Gallery 18' },
  { url: '/images/balloon3/image19', alt: 'Balloon 3 Gallery 19' },
  { url: '/images/balloon3/image20', alt: 'Balloon 3 Gallery 20' },
  { url: '/images/balloon3/image21', alt: 'Balloon 3 Gallery 21' },
  { url: '/images/balloon3/image22', alt: 'Balloon 3 Gallery 22' },
  { url: '/images/balloon3/image23', alt: 'Balloon 3 Gallery 23' },
  { url: '/images/balloon3/image24', alt: 'Balloon 3 Gallery 24' }
];
